'use strict';

function isGtmAlreadyLoaded() {
    return window.dataLayer && window.dataLayer.find(element => element['gtm.start']);
}

function injectGtmFromString(dataStr) {
    var dlScript = $('<div>' + dataStr + '</div>').find('.additional-datalayer-events');
    if (dlScript.length > 0) {
        $('body').append(dlScript[0]);
    }
}

function processEventsFromData(data) {
    // Big try catch to avoid UI blocks duo to injection failures.
    try {

        if (typeof data === 'string') {
            // It's html.
            injectGtmFromString(data);
        }

        if (typeof data === 'object') {
            if (data.dataLayer && data.dataLayer.length > 0) {
                // We have events to push!
                let dlEvents = typeof data.dataLayer === 'string' ? JSON.parse(data.dataLayer): data.dataLayer;
                dlEvents.forEach(evt => {
                    let mergePersonalData = !(evt.doNotMergePersonalData || false);
                    if (!mergePersonalData) {
                        delete evt.doNotMergePersonalData;

                        // is it a login event?
                        if (evt.event === 'login') {
                            delete evt.event;
                            window.__dl.personalData = evt; // New personal data.
                        }
                    }


                    window.__dl.pushEvent(evt, mergePersonalData);
                });
            }

            // Check for GTM. If there's no GTM, we have to init it.
            if (!isGtmAlreadyLoaded() && data.renderedGTM) {
                injectGtmFromString(data.renderedGTM);
            }
        }
    } catch(e) {
        console.log(e);
    }
}

function addCallbackToEvent(evt, callback, timeout) {
    evt.eventCallback = callback;
    evt.eventTimeout = timeout || 1000;
}

module.exports = {
    logout: function() {
        $('a[href*="Login-Logout"], a[href*="logout"]').on('click', function() {
            let evt = {
                event: 'logout'
            };
            window.__dl.pushEvent(evt, false);
        });
    },
    plp: function() {
        $('body').on('showMore:success applyFilter:success applySort:success', function(e, data) {
            processEventsFromData(data);
        });

        $('body').on('plp_lp:data', function(e, eventData) {
            let url = eventData && eventData.config && eventData.config.url;

            // PDP is actually triggering the same event. We add a condition to avoid it.
            if (eventData.config && eventData.config.param && !eventData.config.param.record_per_pagina &&
                url !== 'notify') return;

            let dlData = eventData && eventData.response;
            if (dlData && dlData.dataLayer && !isGtmAlreadyLoaded()) {
                delete dlData.dataLayer;
            } else {
                delete dlData.renderedGTM;
            }
            processEventsFromData(dlData);
        });
    },
    login: function() {
        $('form.login').on('login:success', function(e, data) {
            processEventsFromData(data);
        });
    },
    registration: function() {
        $('body').on('register:success', function(e, data) {
            if (data.dataLayer && data.dataLayer.length > 0 && data.redirectUrl) {
                // We need to add a callback
                try {
                    let evts = JSON.parse(data.dataLayer);
                    if (evts.length > 0) {
                        let redirectUrl = data.redirectUrl;
                        addCallbackToEvent(evts[evts.length - 1], function() {
                            window.location = redirectUrl;
                        }, 2000);
                        data.dataLayer = evts;
                        delete data.redirectUrl; // To avoid redirect from FE JS
                    }
                } catch(e) {
                    console.log('Error while crafting gtm event: ', e);
                }
            }
            processEventsFromData(data);
        });
    },
    passwordReset: function() {
      $('body').on('passwordreset:success', function(e, data) {
          processEventsFromData(data);
      });
    },
    booking: function() {
        $('body').on('booking:onStepChange', function(e, data) {
            processEventsFromData(data);
        });

        $('body').on('booking:login', function(e, data) {
            processEventsFromData(data);
        });

        $('body').on('booking:onQuotationEvent', function(e, data) {
            processEventsFromData(data);
        });
    },
    newsletter: function() {
        $('body').on('newsletter:success', function(e, data) {
           processEventsFromData(data) ;
        });
    }
}